import Layout from "@/components/Layout";
import { createBrowserRouter } from "react-router-dom";
import paths from "./paths";
import { ReactNode, Suspense } from "react";
import MenuListPage from "./MenuListPage";
import SvgRender from "./SvgRender";
import OrderResultPage from "./OrderResultPage";

const lazyComponent = (element: ReactNode): ReactNode => {
  return <Suspense fallback={<></>}> {element} </Suspense>
}

const routes = createBrowserRouter([
  {
    path: ':lang?',
    children: [
      {
        element: <Layout />,
        children: [
          {
            path: paths.MENU_LIST,
            element: lazyComponent(<MenuListPage />)
          },
          {
            path: paths.ORDER_RESULT,
            element: lazyComponent(<OrderResultPage />)
          }
        ]
      }
    ]
  },
  {
    path: paths.ICON_RENDER,
    element: lazyComponent(<SvgRender />)
  }
]);

export default routes;